import { render, staticRenderFns } from "./batchGoods.vue?vue&type=template&id=553a5991&scoped=true&"
import script from "./batchGoods.vue?vue&type=script&lang=js&"
export * from "./batchGoods.vue?vue&type=script&lang=js&"
import style0 from "./batchGoods.vue?vue&type=style&index=0&id=553a5991&lang=less&scoped=true&"
import style1 from "./batchGoods.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a5991",
  null
  
)

export default component.exports